import { registerLocaleData } from '@angular/common';
import localeEN from '@angular/common/locales/en';
import localeUK from '@angular/common/locales/uk';
import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

registerLocaleData(localeEN);
registerLocaleData(localeUK);

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
